export default "__VITE_ASSET__BI5xmtzO__"